if (!customElements.get('related-products-slider')) {
  class RelatedProductsSlider extends HTMLElement {
    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    initSwiper() {
      const swiperEl = this.querySelector('.related-products__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      const prevButton = this.querySelector('.slider-button--prev');
      const nextButton = this.querySelector('.slider-button--next');
      const updateButtons = (swiper) => {
        if (prevButton) prevButton.disabled = swiper.isBeginning;
        if (nextButton) nextButton.disabled = swiper.isEnd;
      };

      const slidesMobile = parseFloat(this.dataset.slidesMobile) || 1.1;
      const mobileGap = parseFloat(getComputedStyle(this).getPropertyValue('--grid-mobile-horizontal-spacing')) || 16;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: slidesMobile,
        spaceBetween: mobileGap,
        watchOverflow: true,
        a11y: true,
        breakpoints: {
          750: {
            slidesPerView: '2.4',
            spaceBetween: 10,
          },
          990: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
        },
        on: {
          init: updateButtons,
          slideChange: updateButtons,
          resize: updateButtons,
        },
      });

      prevButton?.addEventListener('click', () => this.swiper.slidePrev());
      nextButton?.addEventListener('click', () => this.swiper.slideNext());
    }
  }

  customElements.define('related-products-slider', RelatedProductsSlider);
}
